import i18n from "@/plugins/i18n/i18n";

export default (key: string, obj?: any) => ({

	__value: "",

	get value(): any {
		return i18n.t(key)
	},

	set value(v: any) {
		this.__value = v;
	},

	...(obj || {})

});